const types = [
  "RESET_INPUT",
  "SET_VIEWID",
  "SET_DEBUG_LEVEL",
  "SET_LOADING",
  "SET_SCHEMA",
  "SET_LOCALE",
  "SIGN_IN",
  "SIGN_OUT",
  "SET_MODAL_VIEW_SCHEMA",
  "SET_MODAL_TITLE",
  "SET_MODAL_STYLE",
  "CLOSE_MODAL",

  "SET_ACCOUNT_STATE",

  "SET_AXG_STATE",
  "SET_AXG_SCHEMA",

  "SET_AXG_DATA",
  "RESET_AXG_DATA",
]

types.forEach(
  (t) => {
    // console.log(t)
    module.exports[t] = t
  }
)



// WEBPACK FOOTER //
// ./redux/action-types/index.js